import getMessengerConfig, {
  getMessengerToken,
  parseHostPageConfig,
} from "../../../../../../../../lib/client/utils/config";
import getBasePathFromParams from "./getBasePath";
import type { BasePath } from "../../types/routeTypes";
import type {
  MessengerConfig,
  UrlCacheableConfig,
} from "@deskpro-product/messenger-api-schemas/messenger/config";

export default async function initPage(params: {
  hostConfig: string;
  tenantId: string;
  messengerId: string;
}): Promise<{
  config: MessengerConfig;
  basePath: BasePath;
  mediaBaseUrl: string;
  platform: NonNullable<UrlCacheableConfig["platform"]>;
}> {
  const { tenantId, messengerId, hostConfig } = params;
  const urlCacheableConfig = parseHostPageConfig(hostConfig);

  const { config: mergedConfig, mediaBaseUrl } = await getMessengerConfig({
    tenantId,
    messengerId,
    messengerToken: getMessengerToken(hostConfig),
  });

  const basePath = getBasePathFromParams(params);

  return {
    config: mergedConfig,
    mediaBaseUrl,
    basePath,
    platform: urlCacheableConfig?.platform ?? "WEB",
  };
}
